export const SHOW_MENU = 'SHOW_MENU';

export const showMenu = data => {
  return {
    type: SHOW_MENU,
    data
  };
};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/contextmenu/actions.js